import React from "react";
import { defineMessages } from "react-intl";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { BulkActionKey } from "../types.js";
const localized = defineMessages({
  bulkActionSummaryLabelAccountLock: {
    id: "bulkActionSummaryLabelAccountLock",
    defaultMessage: "Account Lock"
  },
  bulkActionSummaryLabelLobbyLock: {
    id: "bulkActionSummaryLabelLobbyLock",
    defaultMessage: "Lobby Lock"
  },
  bulkActionSummaryLabelDepositLock: {
    id: "bulkActionSummaryLabelDepositLock",
    defaultMessage: "Deposit Lock"
  },
  bulkActionSummaryLabelWithdrawalLock: {
    id: "bulkActionSummaryLabelWithdrawalLock",
    defaultMessage: "Withdrawal Lock"
  },
  bulkActionSummaryLabelCasinoLock: {
    id: "bulkActionSummaryLabelCasinoLock",
    defaultMessage: "Casino Lock"
  },
  bulkActionSummaryLabelSportsbookLock: {
    id: "bulkActionSummaryLabelSportsbookLock",
    defaultMessage: "Sportsbook Lock"
  },
  bulkActionSummaryLabelP2PLock: {
    id: "bulkActionSummaryLabelP2PLock",
    defaultMessage: "P2P Transfer"
  },
  bulkActionSummaryLabelAddSecurityCaseID: {
    id: "bulkActionSummaryLabelAddSecurityCaseID",
    defaultMessage: "Add Security Case ID"
  },
  bulkActionSummaryLabelUpdateSecurityCaseID: {
    id: "bulkActionSummaryLabelUpdateSecurityCaseID",
    defaultMessage: "Update Security Case ID"
  },
  bulkActionSummaryLabelRemoveSecurityCaseID: {
    id: "bulkActionSummaryLabelRemoveSecurityCaseID",
    defaultMessage: "Remove Security Case ID"
  },
  bulkActionSummaryLabelSendAMessage: {
    id: "bulkActionSummaryLabelSendAMessage",
    defaultMessage: "Send a Message"
  },
  bulkActionSummaryLabelAddNotesAndAttachment: {
    id: "bulkActionSummaryLabelAddNotesAndAttachment",
    defaultMessage: "Add Notes and Attachment"
  },
  bulkActionSummaryLabelBonusManualTrigger: {
    id: "bulkActionSummaryLabelBonusManualTrigger",
    defaultMessage: "Addition Manual Trigger"
  },
  bulkActionSummaryLabelManualTransactions: {
    id: "bulkActionSummaryLabelManualTransactions",
    defaultMessage: "Add Transactions"
  },
  bulkActionSummaryLabelAddUserLabel: {
    id: "bulkActionSummaryLabelAddUserLabel",
    defaultMessage: "Assign Label {labelValue}"
  },
  bulkActionSummaryLabelRemoveUserLabel: {
    id: "bulkActionSummaryLabelRemoveUserLabel",
    defaultMessage: "Delete Label {labelValue}"
  },
  bulkActionSummaryLabelP2PTransfer: {
    id: "bulkActionSummaryLabelP2PTransfer",
    defaultMessage: "P2P Transfer"
  },
  bulkActionSummaryLabelRejectKYC: {
    id: "bulkActionSummaryLabelRejectKYC",
    defaultMessage: "Reject KYC"
  },
  bulkActionSummaryLabelInitiatePaymentKYC: {
    id: "bulkActionSummaryLabelInitiatePaymentKYC",
    defaultMessage: "Initiate Payment KYC"
  },
  bulkP2PSettings: {
    id: "bulkActionSummaryLabelP2PSettings",
    defaultMessage: "P2P Settings"
  },
  bulkActionSummaryLabelManualCredit: {
    id: "bulkActionSummaryLabelManualCredit",
    defaultMessage: "Update Manual Credit Status"
  },
  bulkActionSummaryLabelCreditRequests: {
    id: "bulkActionSummaryLabelCreditRequests",
    defaultMessage: "Add Credit Requests"
  }
});
const useLabel = (type) => {
  const mapping = {
    [BulkActionKey.AccountLock]: localized.bulkActionSummaryLabelAccountLock,
    [BulkActionKey.DepositLock]: localized.bulkActionSummaryLabelDepositLock,
    [BulkActionKey.LobbyLock]: localized.bulkActionSummaryLabelLobbyLock,
    [BulkActionKey.WithdrawalLock]: localized.bulkActionSummaryLabelWithdrawalLock,
    [BulkActionKey.CasinoLock]: localized.bulkActionSummaryLabelCasinoLock,
    [BulkActionKey.SportsbookLock]: localized.bulkActionSummaryLabelSportsbookLock,
    [BulkActionKey.SecurityCasesAdd]: localized.bulkActionSummaryLabelAddSecurityCaseID,
    [BulkActionKey.SecurityCasesRemove]: localized.bulkActionSummaryLabelRemoveSecurityCaseID,
    [BulkActionKey.SecurityCasesUpdate]: localized.bulkActionSummaryLabelUpdateSecurityCaseID,
    [BulkActionKey.Message]: localized.bulkActionSummaryLabelSendAMessage,
    [BulkActionKey.NotesAndAttachments]: localized.bulkActionSummaryLabelAddNotesAndAttachment,
    [BulkActionKey.ManualTriggerDepositCashMatch]: localized.bulkActionSummaryLabelBonusManualTrigger,
    [BulkActionKey.ManualTriggerMTTTicket]: localized.bulkActionSummaryLabelBonusManualTrigger,
    [BulkActionKey.ManualTriggerImmediateCashBonus]: localized.bulkActionSummaryLabelBonusManualTrigger,
    [BulkActionKey.ManualTriggerCasinoCoinBonus]: localized.bulkActionSummaryLabelBonusManualTrigger,
    [BulkActionKey.ManualTransactions]: localized.bulkActionSummaryLabelManualTransactions,
    [BulkActionKey.AddUserLabel]: localized.bulkActionSummaryLabelAddUserLabel,
    [BulkActionKey.RemoveUserLabel]: localized.bulkActionSummaryLabelRemoveUserLabel,
    [BulkActionKey.P2PTransfer]: localized.bulkActionSummaryLabelP2PTransfer,
    [BulkActionKey.KYCReject]: localized.bulkActionSummaryLabelRejectKYC,
    [BulkActionKey.SecurityCases]: void 0,
    [BulkActionKey.SecurityCasesAll]: void 0,
    [BulkActionKey.ManualTriggerDepositCashMatchAmount]: void 0,
    [BulkActionKey.ManualTriggerDepositCashMatchCode]: void 0,
    [BulkActionKey.InitiatePaymentKYC]: localized.bulkActionSummaryLabelInitiatePaymentKYC,
    [BulkActionKey.KYCAssign]: void 0,
    [BulkActionKey.TransactionAssign]: void 0,
    [BulkActionKey.P2PSettings]: localized.bulkP2PSettings,
    [BulkActionKey.CreditReqeusts]: localized.bulkActionSummaryLabelCreditRequests,
    [BulkActionKey.ManualCredit]: localized.bulkActionSummaryLabelManualCredit
  };
  return mapping[type];
};
const BulkSummaryStepActionLabel = ({ actionKey, labelValue }) => {
  const label = useLabel(actionKey);
  return /* @__PURE__ */ React.createElement(LocalizedText, { label, labelParams: { labelValue } });
};
export {
  BulkSummaryStepActionLabel
};
//# sourceMappingURL=BulkSummaryStepActionLabel.js.map
